import { render, staticRenderFns } from "./sms-detail.vue?vue&type=template&id=f9279c30&scoped=true&"
import script from "./sms-detail.vue?vue&type=script&lang=js&"
export * from "./sms-detail.vue?vue&type=script&lang=js&"
import style0 from "./sms-detail.vue?vue&type=style&index=0&id=f9279c30&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9279c30",
  null
  
)

export default component.exports